var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UnitList',{attrs:{"units":_vm.unitList,"fields":_vm.fields,"sortBy":"dateConfigPull"},on:{"selectUnit":_vm.selectUnit}})}
var staticRenderFns = []

export { render, staticRenderFns }